<template>
	<button
		:disabled="$attrs.disabled"
		class="card"
		:class="{
			selected: selected,
			hover: hover,
			inline: inline
		}"
		tabindex="0"
		@mousedown.prevent
	>
		<h3 v-if="title">{{ title }}</h3>
		<slot></slot>
	</button>
</template>
<script>
export default {
	props: {
		selected: {
			type: Boolean,
			default: false
		},
		inline: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: null,
			required: false
		},
		hover: {
			type: Boolean,
			default: true
		}
	}
};
</script>
<style lang="scss" scoped>
.card {
	font-family: 'RobotoRegular';
	font-size: 15px;
	padding: 24px 32px;
	background-color: $container-bgcolor;
	color: $questionnaire-color;
	border: 1px solid $container-border;
	border-radius: 8px;
	box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
	margin-bottom: 16px;
	line-height: 23px;
	text-align: left;
	display: block;

	h3 {
		height: 26px;
		width: 100%;
		margin-top: 0px;
		margin-bottom: 8px;
		@media (min-width: $breakpoint-mid) {
			margin-bottom: 16px;
		}
	}

	&:not(.inline) {
		width: 100%;
	}

	&.inline {
		text-align: center;
	}

	@media (min-width: $breakpoint-mid) {
		padding: 32px 64px;
		font-size: 18px;
		line-height: 26px;
		margin-bottom: 24px;
	}

	&:disabled,
	&:disabled:hover,
	&.selected:disabled,
	&.selected:disabled:hover {
		cursor: not-allowed !important;
		background-color: $disabled-state !important;
		border-color: $disabled-state !important;
		opacity: 0.5;
		color: $font-dark !important;
	}
}
</style>
